"use client";

import { use } from "react";
import SignInForm from "./SignInForm";
export default function SignInPage(props: {
  params: Promise<{
    amt: string;
  }>;
  searchParams: Promise<{
    [key: string]: string | string[] | undefined;
  }>;
}) {
  const searchParams = use(props.searchParams);
  const params = use(props.params);
  return <SignInForm params={params} searchParams={searchParams} data-sentry-element="SignInForm" data-sentry-component="SignInPage" data-sentry-source-file="page.tsx" />;
}